import { useContext } from 'react';
import { CanvasContext } from 'context/canvas-context/canvas-context';
import { FlipAnimation } from 'canvas/animations/flip-animation';
import { FlippedLayer } from 'flipped-layer/flipped-layer';

export function useHandTool() {
	const { renderingManager, animationsManager } = useContext(CanvasContext);

	return function ({ pageX, pageY }: MouseData) {
		const layer = renderingManager?.findLayerByCoordinates(pageX, pageY);

		if (layer && renderingManager) {
			const type = layer.getType();

			if (type === 'flipped-layer') {
				const stickerAnimation = new FlipAnimation(
					layer,
					renderingManager
				);

				stickerAnimation.onFlipInMiddle(() => {
					(layer as FlippedLayer).switch();
				});

				animationsManager?.add(stickerAnimation);
			}
		}
	};
}
